import { style } from 'typestyle';
import { rem } from 'csx';
import { companionStyles } from '../../common-ui/components/CompanionListView/CompanionListView.styles';

const tabsContainer = style({
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'sticky',
  top: 0,
  zIndex: 50, // style edit name/desc fields have a value of 40
  backgroundColor: 'white',
  paddingBottom: rem(0.25),
  $nest: {
    // removes ugly outline on selected tab and menu button
    '& button:focus': {
      outline: 'none',
    },
    '& .override-title': {
      fontSize: '1.8rem',
      fontWeight: 300,
      margin: 0,
      marginRight: 'auto',
      whiteSpace: 'nowrap',
      fontFamily: '"Open Sans", sans-serif',
      lineHeight: 1.2,
    }
  },
});

export const worklistContainer = style({
  $debugName: 'worklistContainer',
  display: 'flex',
  height: '100%',
  $nest: {
    '.data-container': {
      display: 'flex',
      flex: 1,
      minWidth: 1,
    },
  },
});

export const worklistViewContainer = (isPrintMode: boolean) =>
  style({
    $debugName: 'worklistViewContainer',
    overflow: isPrintMode ? 'visible' : 'hidden',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    $nest: {
      '.data-container': {
        overflow: isPrintMode ? 'visible' : 'hidden',
        $nest: {
          '& .title': {
            fontSize: rem(1.8),
            fontWeight: 300,
            margin: 0,
            marginRight: '0.5rem',
            whiteSpace: 'nowrap',
          },
          '& .override-title': {
            marginRight: 'auto',
          },
        },
      },
    },
  });

export const worklistCompanionViewContainer = (hideCompanion: boolean | undefined = false) => {
  return style({
    $debugName: 'worklist-companion-view',
    display: hideCompanion ? 'none' : 'flex',
    flexDirection: 'column',
    $nest: {
      [`& .${companionStyles}`]: {
        flexGrow: 1,
      },
    },
  });
};

const styleEditPreview = style({
  display: 'flex',
  marginBottom: 20,
  width: '100%',
});

const WORKLIST_TAB_HEIGHT = 52;

export default {
  tabsContainer,
  worklistViewContainer,
  styleEditPreview,
  WORKLIST_TAB_HEIGHT,
};
